import React, { createContext, useContext, useReducer } from 'react';


const realtimeState = (
  localStorage.getItem('realtimeState')
    ?
  JSON.parse(localStorage.getItem('realtimeState'))
    :
  {
    choice: 'active',
    pickers: {
      groups: [],
      locations: {
        all: [], show: []
      }
    },
    selected: {
      groups: [],
      locations: []
    }
  }
);

const RealtimeContext = createContext();
export const RealtimeProvider = ({ reducer, children }) => (
  <RealtimeContext.Provider value={useReducer(reducer, realtimeState)}>
    {children}
  </RealtimeContext.Provider>
);

export const useRealtimeContext = () => useContext(RealtimeContext);
